import React from "react";

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";
import NavLinkAdapter from "../../../../../../../@BASE/core/NavLinkAdapter";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
// Custom Components
import { ImageAttribution } from "../components/ImageAttribution";
import Instructions from "../components/Instructions";

const PEDecisionEvent = (props) => {
  const { data, dir, ins, course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>

      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
        noInstructions
      />

      <Typography className="text-16 font-bold p-16 pb-0">
        Page Content:
      </Typography>

      {data.core.map((card, num) => (
        <Paper
          key={num}
          elevation={0}
          variant="outlined"
          square
          className="p-16 m-16"
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box className="flex items-center w-full">
                <Typography className="text-14 font-bold grow">
                  Option {num + 1}:
                </Typography>
                <Chip
                  icon={
                    <BASESvgIcon size={20}>heroicons-outline:chat</BASESvgIcon>
                  }
                  label={componentCommentsCount(card.id)}
                  variant="outlined"
                  className="mx-16"
                />
                <Button
                  variant="outlined"
                  color="primary"
                  component={NavLinkAdapter}
                  to={`comments/new/edit?c=${card.id}&t=${card.title_en}`}
                  startIcon={
                    <BASESvgIcon size={20}>heroicons-outline:plus</BASESvgIcon>
                  }
                  size="small"
                >
                  Add
                </Button>
              </Box>
              <Divider className="my-16" />
            </Grid>
            <Grid item xs={12}>
              <ImageAttribution attribution={card.media} tl={tl} dir={dir} />
            </Grid>

            <Grid item xs={12}>
              <Paper elevation={0} variant="outlined" square className="p-16">
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <Typography className={`${tl} m-0`} dir={dir}>
                          {card.title_tl}
                        </Typography>
                        <Divider className="my-16" />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography
                          className={`${tl} m-0`}
                          dir={dir}
                          dangerouslySetInnerHTML={{ __html: card.text_tl }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <Paper elevation={0} variant="outlined" square className="p-16">
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <Typography className="text-14 font-semibold m-0">
                          {card.title_en}
                        </Typography>
                        <Divider className="my-16" />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography
                          className="text-14 m-0"
                          dangerouslySetInnerHTML={{ __html: card.text_en }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Paper>
      ))}
    </div>
  );
};

export default PEDecisionEvent;
